import { ModalFooter } from 'components/modals/ModalFooter';
import { ModalHeader } from 'components/modals/ModalHeader';
import { useForm } from 'react-hook-form';
import { t } from 'utils/getTranslations';

import CheckboxInput from 'components/forms/inputs/rhf-inputs/CheckboxInput.tsx';
import TextInput from 'components/forms/inputs/rhf-inputs/TextInput.tsx';
import { DocumentTemplateUpdateDto } from 'types/document-templates.ts';

interface Props {
    titleId?: string;
    onChange: (value: DocumentTemplateUpdateDto) => void;
    onClose: () => void;
    documentTemplate: DocumentTemplateUpdateDto;
}

const DocumentTemplateEditModal = (props: Props) => {
    const { titleId = 'document-template.edit-modal-title', onClose, onChange, documentTemplate } = props;

    const defaultValues: DocumentTemplateUpdateDto = {
        name: documentTemplate.name ?? '',
        isDefault: documentTemplate.isDefault ?? false,
        id: documentTemplate.id,
    };

    const { handleSubmit, control } = useForm<DocumentTemplateUpdateDto>({
        defaultValues: defaultValues,
    });

    const handleOnChange = (data: DocumentTemplateUpdateDto) => {
        onChange(data);
        onClose();
    };

    const onSave = async () => {
        await handleSubmit((data) => handleOnChange(data))();
    };

    return (
        <>
            <ModalHeader title={t(titleId)} onCancel={onClose} />
            <div className="h-full overflow-y-auto px-[23px] pt-[15px] pb-[45px]">
                <div className="flex flex-col gap-4">
                    <TextInput
                        name="name"
                        control={control}
                        label="name"
                        placeholder="name"
                        required
                        inputProps={{ min: 0, max: 60 }}
                    />
                    <CheckboxInput
                        name="isDefault"
                        control={control}
                        label={'document-template.is-default'}
                        readonly={false}
                    />
                </div>
            </div>
            <ModalFooter
                onCancel={onClose}
                onSave={() => {
                    void onSave();
                }}
            />
        </>
    );
};

export default DocumentTemplateEditModal;
